import { Dayjs } from 'dayjs'
import stringify from 'fast-safe-stringify'

import { day, dayOfWeek, getOnlyDate, isHoliday } from '~/astra'
import { GetStaffingPlanExecutionsParams } from '~/clients/derived-api-types'

import { isNullish } from './guards'

export function isNumber(s?: unknown): s is number {
    return !isNaN(Number(s))
}

export function getNonEmptyString(s?: string | null): string | undefined {
    if (isNullish(s)) {
        return undefined
    }
    return s.trim() === '' ? undefined : s
}

export const getEntityDateArgs = (startDate: Dayjs, endDate: Dayjs) => ({
    'scheduled_date:gte': getOnlyDate(startDate),
    'scheduled_date:lte': getOnlyDate(endDate),
})

export const getEntityYearArgs = (date: Dayjs) => ({ year: date.year(), month: date.month() + 1 }) satisfies GetStaffingPlanExecutionsParams

export function getHolidayStyles(date: Dayjs | string) {
    date = typeof date === 'string' ? day(date) : date
    const disabledStyles = '!bg-fill-brand-disabled/25'
    return isHoliday(date) ? disabledStyles : false
}

export function getFridayStyles(date: Dayjs | string) {
    date = typeof date === 'string' ? day(date) : date
    const fridayStyles = 'border-r-2 '
    return dayOfWeek(date) === 5 ? fridayStyles : ''
}

/**
 * @param _ Pass an argument that at compile-time should resolve to `never`.
 * @param optional To print alongside the generic error message. `undefined` logs nothings (=default). Be sure not to log sensitive information.
 */
export function assertUnreachable(_: never, optional?: unknown): Error {
    const message = `Didn't expect to get here${optional !== undefined ? `. ${stringify(optional)}` : ''}`

    // we return an error such that you can easily do `throw assertUnreachable(...)`
    console.error(message)
    return new Error(message)
}

export function getScheduleStatusesGap(scheduleStatusesLength: number) {
    if (scheduleStatusesLength === 2) {
        return 'two-children'
    }
    if (scheduleStatusesLength === 3) {
        return 'three-children'
    }
    if (scheduleStatusesLength >= 4) {
        return '-space-x-4'
    }
}

export function pluralize(count: number, noun: string, suffix = 'er') {
    return count === 1 ? noun : `${noun}${suffix}`
}

export function formatNumberToNorwegian(num: number, fraction?: number) {
    return num.toLocaleString('no-NO', { maximumFractionDigits: fraction })
}
